/* @flow weak */
import PaymentHeaderActions from 'rsvp/actions/PaymentHeaderActions';
import React from 'react';

/**
 * This component wraps a component within one of the payments routes to
 * allow the navigation components in the upper right of the PaymentHeader
 * to be hidden while the component is mounted.
 *
 * e.g.
 *
 * var CardView = React.createClass({
 *   render() {
 *     return <CardInput />;
 *   }
 * });
 *
 * export default withoutPaymentHeader(CardView);
 */
export default function withoutPaymentHeader(Component) {
  const wrapper = React.createClass({
    componentDidMount() {
      PaymentHeaderActions.hideNavigation();
    },

    componentWillUnmount() {
      PaymentHeaderActions.showNavigation();
    },

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
        />
      );
    },
  });

  return wrapper;
}



// WEBPACK FOOTER //
// ./src/payments/utils/withoutPaymentHeader.js